import { createContext } from 'react';
import { defaultAssociationsContextProps } from './constants';
export const AssociationsPropsContext = /*#__PURE__*/createContext(defaultAssociationsContextProps);